import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Minus } from 'phosphor-react';
import { personenAutoStyles as styles } from '../../../styles/commonStyles';
import { AUTO_COVERAGE_MATRIX_ROWS, type AutoVariant } from './coverages';

export const CoverageMatrix: React.FC<{ selectedHoofd: AutoVariant; open: boolean }> = ({ selectedHoofd, open }) => {
  const { t } = useTranslation();

                const matrixRows = AUTO_COVERAGE_MATRIX_ROWS;
                const isCol = (col: 'WA' | 'WA+' | 'WA+volledig') => selectedHoofd === col;
                const colClass = (col: 'WA' | 'WA+' | 'WA+volledig') =>
                  `personenauto-coverage-matrix-col${isCol(col) ? ' personenauto-coverage-matrix-col--selected' : ''}`;
                // Not-covered cells show a neutral dash, never a cross (reads as a fault).
                const renderMark = (covered: boolean) =>
                  covered
                    ? <Check size={20} weight="bold" color="var(--success-color, #22c55e)" />
                    : <Minus size={20} weight="bold" color="#c4ccd0" aria-label="–" />;
                return (
                  <div
                    className={`personenauto-coverage-glance${open ? ' personenauto-coverage-glance--open' : ''}`}
                    style={{ ...styles.toggleRow, ...styles.toggleRowColumnOverride }}
                  >
                    <div style={styles.colGap4}>
                      <span style={styles.label15}>
                        {t('screens.personenauto.coverageMatrix.title')}
                      </span>
                      <span style={styles.hint13}>
                        {t('screens.personenauto.coverageMatrix.sectionTitle')}
                      </span>
                    </div>
                    <div className="personenauto-coverage-matrix">
                      <div className="personenauto-coverage-matrix-grid" style={styles.coverageMatrixHeaderRow}>
                        <div />
                        <div className={colClass('WA')} style={{ ...styles.coverageMatrixHeader, ...(isCol('WA') ? styles.coverageMatrixHeaderActive : {}) }}>{t('screens.personenauto.coverage.wa')}</div>
                        <div className={colClass('WA+')} style={{ ...styles.coverageMatrixHeader, ...(isCol('WA+') ? styles.coverageMatrixHeaderActive : {}) }}>{t('screens.personenauto.coverage.waPlus')}</div>
                        <div className={colClass('WA+volledig')} style={{ ...styles.coverageMatrixHeader, ...(isCol('WA+volledig') ? styles.coverageMatrixHeaderActive : {}) }}>{t('screens.personenauto.coverage.waFull')}</div>
                      </div>
                      {matrixRows.map((row) => (
                        <div
                          key={row.key}
                          className="personenauto-coverage-matrix-grid"
                          style={styles.coverageMatrixRow}
                        >
                          <div style={styles.coverageMatrixLabel}>
                            {t(`screens.personenauto.coverageMatrix.rows.${row.key}`)}
                          </div>
                          <div className={colClass('WA')} style={{ ...styles.coverageMatrixCell, ...(isCol('WA') ? styles.coverageMatrixCellActive : {}) }}>{renderMark(row.wa)}</div>
                          <div className={colClass('WA+')} style={{ ...styles.coverageMatrixCell, ...(isCol('WA+') ? styles.coverageMatrixCellActive : {}) }}>{renderMark(row.waPlus)}</div>
                          <div className={colClass('WA+volledig')} style={{ ...styles.coverageMatrixCell, ...(isCol('WA+volledig') ? styles.coverageMatrixCellActive : {}) }}>{renderMark(row.waFull)}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              };
